import { getCountryCodeByName } from '@heidi/utils/countries';

import { useUser } from './useQueryUser';

/**
 * The logged-in user's ISO country code
 */
export const useUserCountryCode = (): string | undefined => {
  const { data: userCountryCode } = useUser((user) =>
    getCountryCodeByName(user?.country)
  );

  return userCountryCode;
};
